<template>
  <div id="chat" class="flex flex-col md:flex-row items-start">
    <!-- eslint-disable  vue/no-v-html -->
    <div class="order-last md:order-first flex-shrink-0 text-grey-300 text-15 mr-20 w-110">
      <UserBadge
        :first-name="message.user.profile.firstName"
        :last-name="message.user.profile.lastName"
        :color="message.user.profile.color"
        color-height="h-18"
        class="text-app-color rounded-6 py-3 px-10"
        :class="isDarkMode ? 'bg-book' : 'bg-white shadow-user-badge border border-grey-500'"
        max-width="max-w-80"
      />

      <p class="order-first md:order-last text-12 text-grey-300 text-right cursor-default" :title="titleTime">{{ getTime }}</p>
    </div>

    <div
      class="text-app-color rounded-8 break-words"
      v-html="replaceText"
    />
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import { parseDate } from '@/plugins/filters'

export default defineComponent({
  props: {
    message: Object,
    classes: [String, Array]
  },

  setup (props) {
    const { state, getters } = useStore()

    const user = computed(() => state.profile.user)

    const isDarkMode = computed(() => getters.isDarkMode)

    const getTime = computed(() => {
      const minutes = (Date.now() - new Date(props.message.createdAt)) / 1000 / 60
      if (minutes < 1) {
        return 'now'
      } else if (minutes < 2) {
        return '1 minute ago'
      } else if (minutes < 60) {
        return `${parseInt(minutes)} minutes ago`
      } else if (minutes / 60 < 2) {
        return '1 hour ago'
      } else if (minutes / 60 < 24) {
        return `${parseInt(minutes / 60)} hours ago`
      } else if (minutes / 60 > 24 && minutes / 60 / 24 < 8) {
        if (parseInt(minutes / 60 / 24) === 1) return `${parseInt(minutes / 60 / 24)} day ago`
        return `${parseInt(minutes / 60 / 24)} days ago`
      }
      return parseDate(props.message.createdAt, 'DD-MM-YYYY')
    })

    const titleTime = computed(() => {
      return parseDate(props.message.createdAt, 'DD-MM-YYYY hh:mm')
    })

    const hasText = computed(() => {
      var span = document.createElement('span')
      span.innerHTML = props.message.text
      return span.textContent.trim() !== '' || span.innerText.trim() !== ''
    })

    const replaceText = computed(() => {
      return props.message.text.replace(/(<br>)+/g, '<br>').replace(/(@)+/g, '')
    })

    return {
      // computed
      user,
      isDarkMode,
      titleTime,
      getTime,
      hasText,
      replaceText
    }
  }
})
</script>
